import { ChainsListPageTitle } from '../ChainsListPageTitle';
import { ChainsSkeleton } from '../ChainsSkeleton';

export const ChainsListPageSkeleton = () => {
  return (
    <>
      <ChainsListPageTitle />
      <ChainsSkeleton />
    </>
  );
};
